module.exports = __webpack_public_path__ + "static/media/low_doorstep.edbd01c3.png";